// The pages below a Settings category that is a list of its own: `/settings/customisation` lists them, `/settings/customisation/<key>` shows one.
export interface SettingsSubsection {
  key: string
  icon: string
  titleKey: string // (i18n key of the entry's title)
  hintKey: string // (i18n key of the short line below it)
}

export type SubsectionParent = 'customisation' | 'debug'

export const SETTINGS_SUBSECTIONS: Record<SubsectionParent, readonly SettingsSubsection[]> = {
  customisation: [
    { key: 'maps', icon: '🗺️', titleKey: 'settings.maps.title', hintKey: 'settings.customisation.mapsHint' },
    { key: 'links', icon: '🔗', titleKey: 'settings.protocols.title', hintKey: 'settings.customisation.linksHint' },
    { key: 'hashtags', icon: '#️⃣', titleKey: 'settings.tagStyles.title', hintKey: 'settings.customisation.hashtagsHint' },
    { key: 'bullets', icon: '•', titleKey: 'settings.listBullets.title', hintKey: 'settings.customisation.bulletsHint' },
    { key: 'listview', icon: '🗂️', titleKey: 'settings.listView.title', hintKey: 'settings.customisation.listViewHint' },
  ],
  debug: [{ key: 'posts', icon: '📌', titleKey: 'posts.title', hintKey: 'settings.debug.postsHint' }],
}

// The old top level categories that moved below another one, for the redirects of their former URLs.
export const MOVED_SECTIONS: Record<string, string> = {
  protocols: '/settings/customisation/links',
  posts: '/settings/debug/posts',
}

export function hasSubsections(section: string | undefined): section is SubsectionParent {
  return section !== undefined && Object.prototype.hasOwnProperty.call(SETTINGS_SUBSECTIONS, section)
}

// `rest` is the route's `:rest*` parameter (what follows `/settings/<section>/`): `[]` or `['links']`.
export type SubsectionView =
  | { view: 'list' }
  | { view: 'page'; subsection: SettingsSubsection }
  | { view: 'unknown' }

export function parseSubsectionPath(section: SubsectionParent, rest: string | string[] | undefined): SubsectionView {
  const parts = (Array.isArray(rest) ? rest : [rest ?? '']).filter((part) => part !== '')
  if (!parts.length) return { view: 'list' }
  const subsection = parts.length === 1 ? SETTINGS_SUBSECTIONS[section].find((entry) => entry.key === parts[0]) : undefined
  return subsection ? { view: 'page', subsection } : { view: 'unknown' }
}

// Where Back goes from a sub page: up to the category's list; the list itself goes to `/settings`.
export function subsectionParent(section: SubsectionParent, view: SubsectionView): string {
  return view.view === 'page' ? `/settings/${section}` : '/settings'
}
